import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { PopupProvider } from "./Components/Popup/TabPopupContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <PopupProvider>

                <App />
            </PopupProvider>

        </BrowserRouter>
    </Provider>
);